/**
 * Public API stub for 'microsoft-adal-angular6'.
 * Use this when the real package is not compatible with current Angular (e.g. Ivy).
 * Path mapping in tsconfig.json: "microsoft-adal-angular6": ["src/app/_Core/_Stubs/adal-public-api.ts"]
 */

import { NgModule } from '@angular/core';
import { MsAdalAngular6ServiceStub } from './adal-stub.service';

export { MsAdalAngular6ServiceStub as MsAdalAngular6Service };

@NgModule({})
export class MsAdalAngular6Module {
  static forRoot(config?: any) {
    return {
      ngModule: MsAdalAngular6Module,
      providers: [MsAdalAngular6ServiceStub]
    };
  }
}
